import React, { useCallback } from 'react';
import styled, { css } from 'styled-components';
import { STRINGS } from 'config';
import { consultationSelector } from 'redux/selectors/consultation';
import { useMappedState } from 'redux-react-hook';
import Card from 'styles/blocks/card';
import { Spinner } from 'styles/blocks/spinner';

const dotStyles = css`
  background-color: ${props => props.theme.buttonPrimaryBackgroundColor};
`;

const spinnerStyles = css`
  margin-left: 10px;
  animation-duration: 2s;
`;

const ETriageBackButton = styled(Card.ButtonSmall)`
  font-size: ${props => props.theme.fontSizeMedium};
  color: ${props => props.theme.fontColorPrimary}
  position: absolute;
  left: 20px;
  padding-left: 0;
  background: transparent;
  border: 1px solid white;
  border-radius: 20px;
  padding: 10px 40px;
  align-items: baseline;
`;

const ETriageStartOverButton = styled(Card.ButtonSmall)`
  font-size: ${props => props.theme.fontSizeMedium};
  color: ${props => props.theme.fontColorPrimary}
  position: absolute;
  right: 20px;
  padding-right: 0;
  background: transparent;
  border: 1px solid white;
  border-radius: 20px;
  padding: 10px 40px;
  align-items: baseline;
`;
const ETriageNavigationBar = styled(Card.Footer)`
  padding-top: 5px;
  height: 40px;
  box-sizing: content-box;
  margin-bottom: 20px;
`;

export function BackwardsNavigation({ product, children, onPrevious, onStartOver }) {
  const mapState = useCallback(state => consultationSelector(state), []);
  const {
    isForwardNavigation,
    isLoading,
    previous,
    isPreviousBlocked,
    isETriageBackHidden,
  } = useMappedState(mapState);
  if (product === STRINGS.PRODUCT.PRIMARY_CARE || product === STRINGS.PRODUCT.E_SPECIALIST) {
    return (
      <>
        {children}
        {previous && !isPreviousBlocked && (
          <Card.Footer>
            <Card.ButtonSmall onClick={onPrevious}><Card.PrevCaret transform="rotate(270)" />Previous step</Card.ButtonSmall>
            <Spinner isVisible={isLoading && !isForwardNavigation} spinnerStyles={spinnerStyles} dotStyles={dotStyles} />
          </Card.Footer>
        )}
      </>
    );
  }
  return (
    <>
      <ETriageNavigationBar isSetToTop>
        {!isETriageBackHidden && (
          <ETriageBackButton onClick={onPrevious}><Card.BackIcon /><Card.BackText>Back</Card.BackText></ETriageBackButton>
        )}
        <ETriageStartOverButton onClick={onStartOver}><Card.HomeIcon /><Card.HomeText>Start again</Card.HomeText></ETriageStartOverButton>
      </ETriageNavigationBar>
      {children}
    </>
  );
}
